<!--  -->
<template>
<el-form-item :label="form.name" :prop="form.model"
                :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
                style="padding-left:10px;line-height:36px;"
                >
    <el-radio-group v-model="value[form.model]"  @change="onInput" :disabled="inputDisable"  style="width:226px">
      <el-radio v-for="item in form.options.options" :key="item.value"  :label='item.value' >{{item.label}}</el-radio>
    </el-radio-group>
  </el-form-item>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
name:'DynamicRadio',
//import引入的组件需要注入到对象中才能使用
components: {},
 data () {
    return {
      key: '',
      formData: {},
      mainValue: ''
    }
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
              options: {
                inline: true,
                defaultValue: "",
                showLabel: false,
                options: [
                  {
                    "value": "0",
                    "label": ""
                  },
                  {
                    "value": "1",
                    "label": ""
                  }
                ],
                required: false,
                width: "",
                remote: false,
                remoteOptions: [],
                props: {
                  "value": "value",
                  "label": "label"
                },
                remoteFunc: () => {},
                 changeFunc: () => {},
                customClass: "",
                labelWidth: 100,
                isLabelWidth: false,
                hidden: false,
                dataBind: true,
                disabled: false
              },
              name: "",
              novalid: {},
              key: "",
              model: "value",
              rules: []
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => { return {} }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        if(val[this.form.model]!=undefined){
           this.value[this.form.model] =  this.value[this.form.model].toString()
        }
        this.mainValue = val
      }
    }
  },
  methods: {
    onInput (val) {
      let that = this
      that.$emit('input', that.value, that.form.model)
      if (typeof that.form.options.changeFunc === 'function') { // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
    },
    setValue (val) {
      this.mainValue = val
    },
    onFocus () {
      let that = this
      if (typeof that.form.options.onFocus === 'function') { // 判断是否存在数据改变事件
        that.form.options.onFocus()
      }
    }
  },
  created () {
    let that = this
    that.key = that.form.key
    if (that.form.hasOwnProperty('options')) {
      that.value[that.form.model] = that.value[that.form.model] || this.form['options']['defaultValue'] || ''
    }
    // 下拉框数据
    if (that.form.hasOwnProperty('options')) {
      if (that.form.options.hasOwnProperty('remoteSearch')) {
        that.remoteSearchFunc = that.form['options']['remoteSearchFunc']
      }
      if (!that.form['options']['remote']) {
        if (that.form['options'].hasOwnProperty('options')) {
          that.optionData = that.form['options']['options']
        }
      } else {
        if (that.form['options'].hasOwnProperty('remoteFunc')) {
          if (typeof that.form['options']['remoteFunc'] === 'function') {
            that.form['options']['remoteFunc'](that, that.forms)
          }
        }
      }
    }
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that)
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

</style>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicRadio.vue"
}
</vue-filename-injector>
